export enum ButtonType {
    button = 'button',
    icon = 'icon',
}
